module.exports = __webpack_public_path__ + "static/media/colonial-pipeline.fb8fb088.svg";